;globalThis["__sentryRewritesTunnelPath__"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"cmcN7jPZQrpN9xhb_q9Jj"};globalThis["__sentryBasePath"] = undefined;globalThis["__rewriteFramesAssetPrefixPath__"] = "";import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  // integrations: [Sentry.replayIntegration()],
  // replaysSessionSampleRate: 0.1,
  // replaysOnErrorSampleRate: 1.0,
  tracesSampleRate: 1,
  debug: false,
  enabled:
    process.env.NODE_ENV === 'production' && (typeof window === 'undefined' || window.location.hostname !== 'localhost'),
});
